import { Injectable } from '@angular/core';
import {HttpClient}from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { User } from './Class/user'
import { map } from 'rxjs/operators';
import {environment} from '../../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class Adm000Service {

  baseUrl: string=environment.baseUrl +'ADM0000/';

  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  public getusr:User;

  constructor(private http:HttpClient) { 

    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    return this.currentUserSubject.value;
}

GetAuthDatas(username:string,password:string):Observable<any>
{
  var loginObj = {userName: username, password: password};
  // return this.http.get<any>(this.baseUrl+'LoginCheck?userName='+username+'&password='+password);
  return this.http.post<any>(this.baseUrl+'LoginCheck', loginObj);

//   return this.http.get<any>(this.baseUrl+'LoginCheck?userName='+username+'&password='+password).pipe(map(user => {
   
//     localStorage.setItem('currentUser', JSON.stringify(user));
//     this.currentUserSubject.next(user);
//     return user;
// }));
 
 // return this.http.get<any>(this.baseUrl+'LoginCheck?userName='+username+'&password='+password);

//   this.http.get<any>(this.baseUrl+'LoginCheck?userName='+username+'&password='+password).pipe(map(user => {
//     // store user details and jwt token in local storage to keep user logged in between page refreshes
//     localStorage.setItem('currentUser', JSON.stringify(user));
//     this.currentUserSubject.next(user);
//     this.getusr=user;
// }));

// return this.currentUser;

}

logout() {
  // remove user from local storage to log user out
  localStorage.removeItem('currentUser');
  this.currentUserSubject.next(null);
}

GetModules():Observable<any>
{
  return this.http.get<any>(this.baseUrl+'GetModules');
}

GetModuleHead(moduleid):Observable<any>
{
  return this.http.get<any>(this.baseUrl+'GetModuleHead/' + moduleid);
}
GetMenu(moduleid):Observable<any>
{
  if (moduleid == null || moduleid == undefined || moduleid == '') {
    moduleid = '0';
  }
  return this.http.get<any>(this.baseUrl+'GetMenu/' + moduleid);
}
GetCompanyDetails():Observable<any>
{
  return this.http.get<any>(this.baseUrl+'GetCompanyDetails');
}

}
